export enum buttonpanelAssetConfig {

    MOBILE_BUTTON_JSON = "assets/buttonpanel/landscape_btns.json",
    //DESKTOP_BUTTON_JSON = "assets/buttonpanel/desktop_userinterface.json",
    SRM_BUTTON_JSON = "assets/buttonpanel/desktop_ui.json",
    PORTRAIT_BUTTON_JSON = "assets/buttonpanel/portrait_btn.json",
    homeButton = "assets/buttonpanel/home_btn.png",
}